"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = MBHeadshot;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gatsbyPluginImage = require("gatsby-plugin-image");
var _hooks = require("gatsby-source-contentful/hooks");
// Packages

// Styles
const ComponentContainer = _styledComponents.default.div.withConfig({
  displayName: "headshot__ComponentContainer",
  componentId: "sc-17ce0n9-0"
})([".headshot{border-radius:50%;height:", "px;max-height:", "px;max-width:", "px;width:", "px;}"], props => props.height, props => props.maxHeight, props => props.maxWidth, props => props.width);
const DefaultHeadshot = _styledComponents.default.div.withConfig({
  displayName: "headshot__DefaultHeadshot",
  componentId: "sc-17ce0n9-1"
})(["--font-size:", "px;border-radius:50%;overflow:hidden;width:48px;height:48px;height:", "px;width:", "px;border:2px solid hsla(204,45%,98%,0.35);display:block;background-color:#264765;display:flex;align-items:center;justify-content:center;color:white;font-weight:700;font-size:20px;line-height:var(--font-size);font-size:var(--font-size);"], props => props.width / 2, props => props.height, props => props.width);

// Main Component
function MBHeadshot({
  professional,
  width,
  height,
  maxWidth,
  maxHeight,
  className
}) {
  var _professional$headsho, _professional$headsho2, _professional$headsho3, _professional$headsho4, _professional$headsho6, _professional$headsho7;
  const contentfulImage = (0, _hooks.useContentfulImage)({
    image: {
      url: (professional === null || professional === void 0 ? void 0 : (_professional$headsho = professional.headshot) === null || _professional$headsho === void 0 ? void 0 : _professional$headsho.url) && (professional === null || professional === void 0 ? void 0 : (_professional$headsho2 = professional.headshot) === null || _professional$headsho2 === void 0 ? void 0 : _professional$headsho2.url.replace(/^(http:|https:)/, "")),
      // useContentful hook adds https to url string
      width: width || 1200,
      height: height || 628
    }
  });
  let image;
  if (professional !== null && professional !== void 0 && professional.headshot && (professional === null || professional === void 0 ? void 0 : (_professional$headsho3 = professional.headshot) === null || _professional$headsho3 === void 0 ? void 0 : _professional$headsho3.title) !== "profile-default" && professional !== null && professional !== void 0 && (_professional$headsho4 = professional.headshot) !== null && _professional$headsho4 !== void 0 && _professional$headsho4.gatsbyImageData) {
    var _professional$headsho5;
    image = (_professional$headsho5 = professional.headshot) === null || _professional$headsho5 === void 0 ? void 0 : _professional$headsho5.gatsbyImageData;
  } else if (professional !== null && professional !== void 0 && professional.headshot && professional !== null && professional !== void 0 && (_professional$headsho6 = professional.headshot) !== null && _professional$headsho6 !== void 0 && _professional$headsho6.url && (professional === null || professional === void 0 ? void 0 : (_professional$headsho7 = professional.headshot) === null || _professional$headsho7 === void 0 ? void 0 : _professional$headsho7.title) !== "profile-default") {
    image = contentfulImage;
  }
  return /*#__PURE__*/_react.default.createElement(ComponentContainer, {
    className: `mb-headshot ${className ? className : ""}`,
    width: width,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight
  }, image ? /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, {
    className: "headshot",
    image: image,
    alt: (professional === null || professional === void 0 ? void 0 : professional.fullName) || (professional === null || professional === void 0 ? void 0 : professional.name) || ""
  }) : /*#__PURE__*/_react.default.createElement(DefaultHeadshot, {
    width: width,
    height: height
  }, `${(professional === null || professional === void 0 ? void 0 : professional.firstName) && (professional === null || professional === void 0 ? void 0 : professional.firstName.charAt())}${(professional === null || professional === void 0 ? void 0 : professional.lastName) && (professional === null || professional === void 0 ? void 0 : professional.lastName.charAt())}`));
}

// Prop Types
MBHeadshot.propTypes = {
  className: _propTypes.default.string,
  professional: _propTypes.default.shape({
    headshot: _propTypes.default.object,
    fullName: _propTypes.default.string,
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    name: _propTypes.default.string
  }),
  /**
   * Logo component can be used or default logo will be used
   */
  logo: _propTypes.default.element,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  maxWidth: _propTypes.default.number,
  maxHeight: _propTypes.default.number,
  url: _propTypes.default.string
};
MBHeadshot.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MBHeadshot",
  "props": {
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "professional": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "headshot": {
            "name": "object",
            "required": false
          },
          "fullName": {
            "name": "string",
            "required": false
          },
          "firstName": {
            "name": "string",
            "required": false
          },
          "lastName": {
            "name": "string",
            "required": false
          },
          "name": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "logo": {
      "description": "Logo component can be used or default logo will be used",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "width": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "height": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "maxWidth": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "maxHeight": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "url": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};